/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

export const FETCH_USER_DATA_REQUEST = "FETCH_USER_DATA_REQUEST";
export const FETCH_USER_DATA_SUCCESS = "FETCH_USER_DATA_SUCCESS";
export const FETCH_USER_DATA_FAILURE = "FETCH_USER_DATA_FAILURE";
export const FETCH_ACTIVE_USERS_SUCCESS = "FETCH_ACTIVE_USERS_SUCCESS";
export const FETCH_PENDING_USERS_SUCCESS = "FETCH_PENDING_USERS_SUCCESS";
export const FETCH_DEACTIVATED_USERS_SUCCESS =
  "FETCH_DEACTIVATED_USERS_SUCCESS";
export const FETCH_ACTIVE_USERS_DOMAIN_COMPANIES =
  "FETCH_ACTIVE_USERS_DOMAIN_COMPANIES";
export const FETCH_ACTIVE_USERS_COMPANIES = "FETCH_ACTIVE_USERS_COMPANIES";
export const ACCEPT_USER_REQUEST = "ACCEPT_USER_REQUEST";
export const FETCH_USER_DATA_COUNT = "FETCH_USER_DATA_COUNT";
export const FETCH_USER_DATA_COUNT_REQUEST = "FETCH_USER_DATA_COUNT_REQUEST";
